<div class="search">
    <app-autocomplete
        placeholder="Buscar:"
    >
        <i 
            noeSuffix
            class="las la-search"
        ></i>
    </app-autocomplete>
</div>